import { c as _c } from "react/compiler-runtime";
import React from "react";
import dynamic from "next/dynamic";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { EditPageProps } from "pages/edit/index.page";
import { Event } from "common/types/graphql";
import { EventsView } from "./Events.view";
export interface EventsProps {
  events?: Event[];
}
const EventsEdit = dynamic<EventsProps>(() => import("./Events.edit").then(mod => mod.EventsEdit));
export const Events = t0 => {
  "use memo";

  const $ = _c(3);
  const {
    events
  } = t0;
  const {
    editing
  } = usePageProps();
  const EventsComponent = editing ? EventsEdit : EventsView;
  let t1;
  if ($[0] !== EventsComponent || $[1] !== events) {
    t1 = <EventsComponent events={events} />;
    $[0] = EventsComponent;
    $[1] = events;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};